import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { SidebarProvider, useSidebar } from '../../contexts/SidebarContext';

const LayoutContent: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { isCollapsed } = useSidebar();
    
    return (
        <div className="flex min-h-screen bg-gray-50">
            <Sidebar />
            {/* Main content with dynamic margin to accommodate sidebar */}
            <div className={`flex-1 flex flex-col transition-all duration-300 ${
                isCollapsed ? 'md:ml-16' : 'md:ml-64'
            }`}>
                <Header />
                <main className="flex-1 p-4 overflow-auto">
                    {children}
                </main>
            </div>
        </div>
    );
};

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <SidebarProvider>
            <LayoutContent>{children}</LayoutContent>
        </SidebarProvider>
    );
};

export default Layout;